import React, { Component, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faEyeSlash,
  faCheckCircle,
  faTimesCircle,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import '../../assets/stylesheets/LoginPage.scss';
import { requestRegister } from '../../store/actionCreators/authentication';
import LanguageSelector from './components/LanguageSelector';
import config from '../../config/config';

const { TERMS_AND_CONDITIONS_URL } = config;

const SignUp = ({}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const regErrorCode = useSelector(state => state.authData.registrationError);
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [userNameIsInvalid, setUserNameIsInvalid] = useState(0);
  const [errorDetais, setErrorDetais] = useState('');
  const [passwordIsValid, setPasswordIsValid] = useState({
    valid: false,
    isEmpty: false
  });
  const [passwordIsHidden, setPasswordIsHidden] = useState(true);
  const [regError, setRegError] = useState(regErrorCode);
  const [userAgreed, setUserAgreed] = useState({
    agreed: !TERMS_AND_CONDITIONS_URL,
    errorText: ''
  });

  const toggleShow = () => {
    setPasswordIsHidden(!passwordIsHidden);
  };

  const changeUsername = e => {
    let withoutSpaces = e.target.value, //.replace(/\s/g, ''),
      //validator = new RegExp("^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$");
      validator = new RegExp('^[a-zA-Z0-9_]*$'); //new RegExp("^[A-Za-z0-9]+(?:[_-][A-Za-z0-9]+)*$");
    let isInvalid = !validator.test(withoutSpaces)
      ? 10
      : withoutSpaces.length < 3
      ? 8
      : withoutSpaces.length > 16
      ? 14
      : 0;
    setUserNameIsInvalid(isInvalid);
    setUserName(withoutSpaces);
    regError && setRegError(false);
  };

  const changePassword = e => {
    let withoutSpaces = e.target.value.replace(/\s/g, ''),
      validator = new RegExp('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$');
    let isValid =
      withoutSpaces.length >= 6 &&
      withoutSpaces.length <= 16 &&
      validator.test(withoutSpaces);
    setPasswordIsValid({
      isEmpty: !(e.target.value.length > 0),
      valid: isValid
    });
    setPassword(e.target.value);
  };

  const registerUser = () => {
    if (
      password.length > 0 &&
      passwordIsValid.valid &&
      username.length > 0 && userNameIsInvalid === 0 &&
      userAgreed.agreed && userAgreed.errorText.length === 0
    ) {
      dispatch(
        requestRegister({ username, password, parentId: config.globalSkinId })
      );
    } else {
      !(password.length > 0 && passwordIsValid.valid) &&
        setPasswordIsValid({ ...passwordIsValid, isEmpty: true });
      (username.length === 0 ) &&
        setUserNameIsInvalid(12);
      !userAgreed.agreed &&
        setUserAgreed({ agreed: false, errorText: t('error.signInUp.11') });
    }
  };

  useEffect(() => {
    setRegError(regErrorCode);
    regErrorCode && regErrorCode.code
      ? setUserNameIsInvalid(regErrorCode.code)
      : userNameIsInvalid > 12 && setUserNameIsInvalid(0);
  }, [regErrorCode]);

  useEffect(() => {

    regErrorCode && regErrorCode.details && regErrorCode.details.includes('already exists')
      ? setErrorDetais('accountWithUsernameAlreadyExists')
      : setErrorDetais('');

  }, [regErrorCode]);

  useEffect(() => {
    setUserAgreed({ ...userAgreed, errorText: '' });
  }, [userAgreed.agreed]);

  

  return (
    <div className="mainLogin">
      <LanguageSelector />
      <div className="logo">
        <div className="title">{t('signUp')} </div>
      </div>
      <div className="inputSection">
        <div className={`userNameField signUp`}>
          {t('signInUp.username')}
          <label className={`${userNameIsInvalid > 0 ? 'fieldError' : ''}`}>
            <input
              type="text"
              className="userNameInput"
              placeholder={t('signInUp.username')}
              onChange={e => changeUsername(e)}
            />
            {userNameIsInvalid > 0 && <span className={`failedField`}></span>}
            {username.length > 0 && userNameIsInvalid === 0 && (
              <span className={`successField`}></span>
            )}
          </label>
          <span className="errorMessage alignErr">
            {username.length > 0
              ? ( errorDetais ? t('error.signInUp.422') : userNameIsInvalid > 0 && t(`error.signInUp.${userNameIsInvalid}`) )
              : userNameIsInvalid === 12 && t('error.signInUp.12')}
          </span>
        </div>

        <div className="passwordField signUp">
          {t('signInUp.password')}
          <label
            className={`${
              (password.length > 0 && !passwordIsValid.valid) ||
              passwordIsValid.isEmpty
                ? 'fieldError'
                : ''
            }`}
          >
            <input
              type={passwordIsHidden ? 'password' : 'text'}
              placeholder={t('signInUp.password')}
              onChange={e => changePassword(e)}
            />
            <button className="password" onClick={toggleShow}>
              {passwordIsHidden ? (
                <FontAwesomeIcon icon={faEyeSlash} color="white" />
              ) : (
                <FontAwesomeIcon icon={faEye} color="grey" />
              )}
            </button>
            {(password.length > 0 && !passwordIsValid.valid) ||
            passwordIsValid.isEmpty ? (
              <span className={`failedField`}></span>
            ) : (
              ''
            )}
            {passwordIsValid.valid && !passwordIsValid.isEmpty && (
              <span className={`successField`}></span>
            )}
          </label>
          <span className="errorMessage alignErr">
            {password.length > 0 && !passwordIsValid.valid
              ? t('error.signInUp.4')
              : passwordIsValid.isEmpty
              ? t('error.signInUp.13')
              : ''}
          </span>
        </div>
        {TERMS_AND_CONDITIONS_URL && <div className="termsAndAgreement">
            <label>
              <span
                className={`mask ${userAgreed.errorText.length > 0 &&
                  !userAgreed.agreed &&
                  'failed'}`}
              >
                {userAgreed.agreed ? <FontAwesomeIcon icon={faCheck} /> : ''}
                <input
                  type="checkbox"
                  className="userAgreement"
                  checked={userAgreed.agreed}
                  onChange={() =>
                    setUserAgreed({ ...userAgreed, agreed: !userAgreed.agreed })
                  }
                />
              </span>
                {t('signInUp.iHaveRead')}
                <a className="tertiary" target="_blank" href={config.TERMS_AND_CONDITIONS_URL}> {t('signInUp.termsLink')} </a> 
                {t('signInUp.and')} 
                <a className="tertiary" target="_blank" href={config.PRIVACY_POLICY_URL}> {t('signInUp.privacyLink')} </a> 
              {userAgreed.errorText.length > 0 && !userAgreed.agreed && (
                <span className="termsError">{userAgreed.errorText}</span>
                // need to check translation
              )}
            </label>
        </div>}
      </div>

      <div className={`register signUp`}>
        <button onClick={() => registerUser()} className={`primary`}>
          {' '}
          {t('signUp')}
        </button>
      </div>
      <p className={`registerLink`}>
        {t('registerObj.text')}
        <Link className="tertiary" to={`/login`}>{t('registerObj.link')}</Link>
      </p>
    </div>
  );
  // }
};

export default SignUp;
